module.exports = __webpack_public_path__ + "img/map_toilet_4.569cf2be.png";